import { css } from "styled-components";
import { FONTS } from "../styles/theme";

// Font families
export const FontFamilyBold = css`
    font-family: ${props => props.theme.font[FONTS.bold]};
`;
export const FontFamilyRegular = css`
    font-family: ${props => props.theme.font[FONTS.regular]};
`;
export const FontFamilyMedium = css`
    font-family: ${props => props.theme.font[FONTS.medium]};
`;

// Font sizes
export const FontSize10 = css`
    font-size: 10px;
`;

export const FontSize12 = css`
    font-size: 12px;
`;

export const FontSize14 = css`
    font-size: 14px;
`;
export const FontSize16 = css`
    font-size: 16px;
`;
export const FontSize18 = css`
    font-size: 18px;
`;
export const FontSize20 = css`
    font-size: 20px;
`;
export const FontSize22 = css`
    font-size: 22px;
`;
export const FontSize32 = css`
    font-size: 32px;
`;

